<script>
export default {
  props: {
    timestamp: {
      type: [String, Number, Date],
      required: true,
    },
    text: {
      type: String,
      default: 'Closes in',
    },
  },
  data() {
    return {
      intervalId: null,
      timeAgo: '',
    };
  },
  mounted() {
    this.calculateTimeAgo();
    this.intervalId = setInterval(this.calculateTimeAgo, 60000); // Update every minute
  },
  beforeUnmount() {
    clearInterval(this.intervalId);
  },
  methods: {
    calculateTimeAgo() {
      const now = Date.now();
      const timeDifference = new Date(this.timestamp * 1000).getTime() - now;

      if (timeDifference < 60000) {
        this.timeAgo = 'soon';
      } else if (timeDifference < 3600000) {
        this.timeAgo = `${Math.floor(timeDifference / 60000)} minutes`;
      } else if (timeDifference < 86400000) {
        this.timeAgo = `${Math.floor(timeDifference / 3600000)} hours`;
      } else {
        this.timeAgo = `${Math.floor(timeDifference / 86400000)} days`;
      }
    },
  },
};
</script>

<template>
  <div>
    <span v-if="text" class="time-ago--text"> {{ text }}: </span>
    <span>{{ timeAgo }}</span>
  </div>
</template>

<style scoped>
.time-ago--text {
  font-style: italic;
}
</style>
